import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getBanners = createAsyncThunk(
  "banner/getBanners",
  async (
    { parPage, page, searchValue },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const data = await api.get("/getBanners");
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const upload_Banner = createAsyncThunk(
  "banner/upload_Banner",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post("/admin/createbanner", payload, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const delete_banner = createAsyncThunk(
  "banner/delete_banner",
  async (bannerId, { rejectWithValue, fulfillWithValue }) => {
    try {
      // console.log(bannerId);
      const { data } = await api.delete(`/banner-delete/${bannerId}`, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const bannerReducer = createSlice({
  name: "banner",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,

    carouselBanners: [],
    totalCarouselBanner: 0,
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: {
    [getBanners.fulfilled]: (state, { payload }) => {
      state.carouselBanners = payload?.data.banners;
      state.loader = false;
      state.successMessage = payload.message;
    },
    [getBanners.pending]: (state, { payload }) => {
      state.loader = true;
    },
    [delete_banner.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.carouselBanners = state.carouselBanners.filter(
        (item, idx) => item._id != payload.bannerId
      );
    },
    [delete_banner.pending]: (state, { payload }) => {
      state.loader = true;
    },


    [upload_Banner.fulfilled]: (state, { payload }) => {
      const updatedBanner = payload.banner;
      const existingIndex = state.carouselBanners.findIndex(
        (b) => b._id === updatedBanner._id
      );

      if (existingIndex !== -1) {
        state.carouselBanners[existingIndex] = updatedBanner;
      } else {
        state.carouselBanners.push(updatedBanner);
      }
    },
  },
});

export const { messageClear, reset_count } = bannerReducer.actions;
export default bannerReducer.reducer;
